import { http } from '@/core/helpers/http.helper';

export class CustomerTypeService {
   async getCustomerTypes() {
      const response = await http.get<ApiResource<Array<CustomerType>>>('/customer-types', {
         ...cacheFirstConfig,
      });
      return response.data;
   }

   async getCustomerType() {
      throw Error('Method not implemented');
   }

   async postCustomerType() {
      throw Error('Method not implemented');
   }

   async putCustomerType() {
      throw Error('Method not implemented');
   }

   async deleteCustomerType() {
      throw Error('Method not implemented');
   }
}
